const CONTRACT_VERSION_PERMISSIONS = {
  // used to represent if the user accepted the code of conduct AND have stock left
  // now only represents if the user accepted the code of conduct
  ADD_NEW_PROPERTY_REVISION: 'add_new_property_revision',
  // successor of ADD_NEW_PROPERTY_REVISION
  // represents if the user reached the stock limit
  ADD_NEW_PROPERTY_REVISION_FOR_STOCK_LIMIT:
    'add_new_property_revision_for_stock_limit',
  CREATE_PROPERTY: 'create_property',
  CREATE_PROPERTY_ZONES: 'create_property_zones',
  ADD_NEW_CHILD: 'add_new_child',
  MONTHS_TO_CREATE_COLAB_CONTRACT: 'months_to_create_colab_contract',
  CAN_SHARE_SELF_SERVICE_LINK: 'can_share_self_service_link',
}

export const CONTRACT_VERSION_PERMISSIONS_LIST = Object.values(
  CONTRACT_VERSION_PERMISSIONS,
)

export default CONTRACT_VERSION_PERMISSIONS
